<ui-confirmation-dialog
    #groupMovementConfirmDialog
    size="small"
    [header]="groupMovementConfirmHeader"
    [attr.data-cy]="'group-movement-confirm-dialog'"
    primaryButtonLabel="settings.custom-fields.move"
    secondaryButtonLabel="cancel"
    primaryButtonType="primary"
>
    <p>{{ confirmationModalMessages[movingGroupTo][0] | translate }}</p>

    <p>{{ confirmationModalMessages[movingGroupTo][1] | translate }}</p>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>

    <ui-card>
        <p>{{ 'settings.custom-fields.reorderFieldGroupsInstruction' | translate }}</p>
        <div class="app-grid margin-top-4">
            <!-- Personal Groups -->
            <div class="columns-6">
                <h4 class="list-title">{{ 'settings.custom-fields.personal' | translate }}</h4>
                <div class="default-groups">
                    <div class="default-group-item" *ngFor="let group of defaultPersonalGroups">
                        <span>{{ group.translatableName | translate }}</span>
                    </div>
                </div>
                <div
                    cdkDropList
                    #personalGroupsList="cdkDropList"
                    [cdkDropListData]="customPersonalGroups"
                    [cdkDropListConnectedTo]="[jobAndPayGroupsList]"
                    class="group-list"
                    id="personalFieldGroups"
                    (cdkDropListDropped)="drop($event, fieldLocationToComponent.personalCustomFields)"
                >
                    <div
                        class="group-item"
                        *ngFor="let group of customPersonalGroups; let i = index"
                        cdkDrag
                        [attr.data-cy]="group.name"
                    >
                        <div class="drag-icon margin-right-1">
                            <mat-icon svgIcon="dragAndDrop"></mat-icon>
                        </div>
                        <span>{{ group.name }}</span>
                    </div>
                </div>
            </div>

            <!-- Job & Pay Groups -->
            <div class="columns-6">
                <h4 class="list-title">
                    {{ 'settings.custom-fields.defaultFieldGroupLabels.job_and_pay' | translate }}
                </h4>
                <div class="default-groups">
                    <div class="default-group-item" *ngFor="let group of defaultJobAndPayGroups">
                        <span>{{ group.translatableName | translate }}</span>
                    </div>
                    <div class="default-group-item">
                        <span>{{ 'settings.custom-fields.currentCompensation' | translate }}</span>
                    </div>
                    <div class="default-group-item">
                        <span>{{ 'settings.custom-fields.compensationHistory' | translate }}</span>
                    </div>
                </div>
                <div
                    cdkDropList
                    #jobAndPayGroupsList="cdkDropList"
                    [cdkDropListData]="customJobAndPayGroups"
                    [cdkDropListConnectedTo]="[personalGroupsList]"
                    class="group-list"
                    id="jobAndPayFieldGroups"
                    (cdkDropListDropped)="drop($event, fieldLocationToComponent.jobAndPayCustomFields)"
                >
                    <div
                        class="group-item"
                        *ngFor="let group of customJobAndPayGroups; let i = index"
                        cdkDrag
                        [attr.data-cy]="'job-and-pay-group-drag-handle-' + i"
                    >
                        <div class="drag-icon margin-right-1">
                            <mat-icon svgIcon="dragAndDrop"></mat-icon>
                        </div>
                        <span>{{ group.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ui-card>
    <div class="flex justify-end">
        <ui-button (click)="onSave()" type="primary">{{ 'save' | translate }}</ui-button>
    </div>
</div>
